export default __webpack_public_path__ + "static/media/user-icon.26345db3.svg";